// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"0ed84bdd","802":"cbae2938"}[chunkId] + ".chunk.js";
};